import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ValorSunatFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='VALOR SUNAT' htmlFor='input-valorSunat' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='valorSunat'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-valorSunat'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ValorSunatFormGroup)
